const UNAUTH_PAGE_TYPE = {
  BOARD: 'board',
  FLASHLIGHT: 'flashlight',
  KLP: 'klp',
  PASSWORDRESET: 'passwordReset',
  PASSWORDUSERNAME: 'passwordUserName',
  PIN: 'pin',
  PINFEEDBACK: 'pinFeedBack',
  PROFILE: 'profile',
  SEARCH: 'search',
  TOPIC: 'topic',
};

export default UNAUTH_PAGE_TYPE;
